import { Routes, Route } from "react-router-dom";
import GoogleAnalytics from "./utils/googleAnalytics";
import { Footer, Navbar, BackToTop } from "./components/compIndex";

import {
  Home,
  Quests,
  Avatars,
  ChangeLogs,
  PlayerLookup,
  GuildLookup,
  PixelAssets,
  TwitterOverlay,
  ItemLookup,
  LandLookup,
  Calculator,
  GuildDetail,
  Energy,
  MyCalendar,
  StarterGuide,
  LandSpeckGuide,
  SkillsGuide,
  PetsGuide,
  LiveOpsGuide,
  About,
  NotFound,
  OtherGuides,
  Leaderboards,
  ItemDirect,
  AnimalCareGuide
} from "./pages/pageIndex";
import { ModalRenderer } from "./components/modalController";
import ItemsMarketplace from "./pages/Lookups/profitLookup";

function App() {

  return (
    <div className="page-background bg-blurred-circles">
      <GoogleAnalytics />
      <div className="App min-h-screen flex flex-col text-white text-xl">
        <Navbar />
        <ModalRenderer />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/wiki/quests/" element={<Quests />} />
            <Route path="/wiki/quests/:id?" element={<Quests />} />
            <Route path="/avatars" element={<Avatars />} />
            <Route path="/wiki/changelogs" element={<ChangeLogs />} />
            <Route path="/lookup/players" element={<PlayerLookup />} />
            <Route path="/lookup/profit" element={<ItemsMarketplace />} />
            <Route path="/lookup/players/:playerId" element={<PlayerLookup />} />
            <Route path="/lookup/guilds" element={<GuildLookup />} />
            <Route path="/lookup/guilds/:handle" element={<GuildDetail />} />
            <Route path="/lookup/guilds/:handle/:tab" element={<GuildDetail />} />
            <Route path="/other/assets" element={<PixelAssets />} />
            <Route path="/other/overlay" element={<TwitterOverlay />} />
            <Route path="/lookup/items" element={<ItemLookup />} />
            <Route path="/lookup/items/:itemId" element={<ItemDirect />} />
            <Route path="/lookup/lands" element={<LandLookup />} />
            <Route path="/tools/calculator" element={<Calculator />} />
            <Route path="/tools/calculator/:tab" element={<Calculator />} />
            <Route path="/tools/energy" element={<Energy />} />
            <Route path="/tools/energy/:tab" element={<Energy />} />
            <Route path="/tools/leaderboards" element={<Leaderboards />} />
            <Route path="/other/calendar" element={<MyCalendar />} />
            <Route path="/wiki/beginner/" element={<StarterGuide />} />
            <Route path="/wiki/beginner/:sectionId" element={<StarterGuide />} />
            <Route path="/wiki/beginner/:sectionId#:subdivisionId" element={<StarterGuide />} />
            <Route path="/wiki/lands/" element={<LandSpeckGuide />} />
            <Route path="/wiki/lands/:sectionId" element={<LandSpeckGuide />} />
            <Route path="/wiki/skills/" element={<SkillsGuide />} />
            <Route path="/wiki/skills/:sectionId" element={<SkillsGuide />} />
            <Route path="/wiki/skills/:sectionId/:skillTab" element={<SkillsGuide />} />
            <Route path="/wiki/animalcare" element={<AnimalCareGuide />} />
            <Route path="/wiki/animalcare/:sectionId" element={<AnimalCareGuide />} />
            <Route path="/wiki/pets/" element={<PetsGuide />} />
            <Route path="/wiki/pets/:sectionId" element={<PetsGuide />} />
            <Route path="/wiki/events/" element={<LiveOpsGuide />} />
            <Route path="/wiki/events/:sectionId" element={<LiveOpsGuide />} />
            <Route path="/wiki/events/:sectionId/:tabId" element={<LiveOpsGuide />} />
            <Route path="/wiki/endgame/" element={<OtherGuides />} />
            <Route path="/wiki/endgame/:sectionId" element={<OtherGuides />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <BackToTop />
        <Footer />
      </div>
    </div>
  );
}

export default App;
